module.exports = __webpack_public_path__ + "static/media/birds-eye-village.d968c8cf.png";